import React from 'react';
import ReactDOM from 'react-dom/client'; // שינוי יבוא מ־'react-dom'
import App from './App';

const rootElement = document.getElementById('root') as HTMLElement; 
const root = ReactDOM.createRoot(rootElement); // יצירת root חדש

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
